import { useEffect, useRef } from 'react';
import { featuresAPI } from '../api';
import { useAppStore } from '../stores/useAppStore';

// Waits before asking again when the request fails, e.g. while the backend restarts during a
// deploy. The last wait repeats until an answer comes back.
const RETRY_DELAYS_MS = [2000, 5000, 15000, 30000];

/**
 * Loads which optional features this branch has switched on (branches.json `features`,
 * e.g. damages) and caches them in the app store. Until an answer arrives the store holds
 * null, so feature routes show a spinner and feature menu entries stay hidden. A failed
 * request is retried rather than read as "everything off", which would hide the feature
 * in that tab until someone reloaded it.
 */
export const useBranchFeatures = () => {
  const setFeatures = useAppStore((s) => s.setFeatures);
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    const load = (attempt) => {
      featuresAPI
        .get()
        .then((res) => setFeatures(res.data || {}))
        .catch(() => {
          const delay = RETRY_DELAYS_MS[Math.min(attempt, RETRY_DELAYS_MS.length - 1)];
          setTimeout(() => load(attempt + 1), delay);
        });
    };
    load(0);
  }, [setFeatures]);
};
